// Display helpers for AI prospect research. Pure, no React.

export const CRITERIA_MAX = 8;

export const STATUS_LABELS = {
  pending: 'Research pending',
  running: 'Research pending',
  complete: 'Research complete',
  failed: 'Research failed — retry',
};

export const PRIORITY_TONES = { HIGH: 'success', MEDIUM: 'warning', LOW: 'neutral' };

export const statusLabel = (result) => (result && STATUS_LABELS[result.status]) || '';

export const priorityTone = (priority) => PRIORITY_TONES[priority] || 'neutral';

export const hasActive = (results) =>
  Array.isArray(results) && results.some((r) => r && (r.status === 'pending' || r.status === 'running'));

export const bestResult = (results) => {
  if (!Array.isArray(results)) return null;
  const done = results.filter((r) => r && r.status === 'complete' && Number.isFinite(r.score));
  if (!done.length) return null;
  return done.reduce((a, b) => (b.score > a.score ? b : a));
};

// Profile form <-> API payload. The form keeps criteria as one textarea (one per line).
export const profileToForm = (p) => ({
  name: (p && p.name) || '',
  description: (p && p.description) || '',
  criteriaText: ((p && p.criteria) || []).join('\n'),
});

export const criteriaFromText = (text) =>
  String(text || '').split('\n').map((c) => c.trim()).filter(Boolean);

export const formToPayload = (f) => ({
  name: f.name.trim(),
  description: f.description.trim(),
  criteria: criteriaFromText(f.criteriaText),
});
